import React from 'react';

/**
 * Hides content visually while leaving it to assistive technology.
 *
 * Used where the design deliberately shows no text but the element still needs
 * a name — the comparison table's first column header, and the proof dialog,
 * which has no header at all.
 */
export const SCREEN_READER_ONLY: React.CSSProperties = {
  position: 'absolute',
  width: 1,
  height: 1,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
};
